module.exports = __webpack_public_path__ + "static/media/2 (42).ef1624a6.jpg";